var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"grid-flex"},[_c('b-avatar',{attrs:{"text":"QS","size":"6rem"}}),_c('h1',[_vm._v("Hi! "),_c('span',{staticClass:"text-color-2"},[_vm._v(_vm._s(_vm.first_name)+" "+_vm._s(_vm.last_name))]),_vm._v("! Welcome to QuietSEAS")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }